import React from "react";
import { X } from "lucide-react";
import LINKS from "./navLinks";

export default function MobileNavDrawer({ open, active, onNavigate, onClose, snapshot }) {
  const bridge = snapshot?.bridge || {};
  return (
    <div
      className={`lg:hidden fixed inset-0 z-50 transition-opacity duration-200 ${open ? "opacity-100" : "opacity-0 pointer-events-none"}`}
      aria-hidden={!open}
    >
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <aside
        data-testid="mobile-nav-drawer"
        className={`absolute left-0 top-0 bottom-0 w-72 max-w-[82vw] bg-[#0B0E17] border-r border-white/10 p-4 flex flex-col transition-transform duration-300 ${open ? "translate-x-0" : "-translate-x-full"}`}
      >
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2.5">
            <div className="w-9 h-9 rounded-xl grid place-items-center bg-gradient-to-br from-amber-400 to-rose-500 text-[#0B0E17] font-black text-[11px]">CAV</div>
            <div className="leading-tight">
              <div className="font-heading font-extrabold text-[13px]"><span className="gold-text">C.A.V</span></div>
              <div className="text-[9px] text-slate-400">Condannati a Vincere</div>
            </div>
          </div>
          <button data-testid="mobile-nav-close" onClick={onClose} className="w-9 h-9 rounded-lg grid place-items-center text-slate-400 hover:text-slate-100 hover:bg-white/5">
            <X size={20} />
          </button>
        </div>

        <div className="text-[10px] uppercase tracking-[0.14em] text-slate-500 px-2 mb-1">Sezioni</div>
        <nav className="grid gap-1 overflow-y-auto">
          {LINKS.map((l) => {
            const Icon = l.icon;
            const isActive = active === l.id;
            return (
              <button
                key={l.id}
                data-testid={`mobile-${l.testid}`}
                onClick={() => onNavigate(l.id)}
                className={`flex items-center gap-3 px-3 py-3 rounded-lg text-[14px] text-left transition-colors ${
                  isActive ? "text-slate-100 bg-[#142033] shadow-[inset_3px_0_0_0_#F59E0B]" : "text-slate-300 hover:text-slate-100 hover:bg-[#141d2e]"
                }`}
              >
                <Icon size={18} className={isActive ? "text-amber-400" : "text-slate-500"} />
                {l.label}
              </button>
            );
          })}
        </nav>

        <div className="mt-auto pt-4">
          <div className={`rounded-xl p-3 border text-[11px] ${bridge.connected ? "border-emerald-500/20 bg-emerald-500/5" : "border-rose-500/20 bg-rose-500/5"}`}>
            <div className="flex items-center justify-between">
              <span className="text-slate-200">Bridge</span>
              <span className={`font-mono font-bold ${bridge.connected ? "text-emerald-400" : "text-rose-400"}`}>{bridge.connected ? "ONLINE" : "OFFLINE"}</span>
            </div>
          </div>
        </div>
      </aside>
    </div>
  );
}
